export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9500.ad0da2a8.jpg";